if (!customElements.get('product-inventory')) {
  class ProductInventory extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.initLazySection.bind(this));
    }

    initLazySection() {
      this.inventoryNotice = this.querySelector('.js-inventory-notice');
      this.urgencyMessage = this.querySelector('.js-inventory-urgency');
      this.indicatorBar = this.querySelector('.js-inventory-indicator');
      this.inventoryTextEle = this.querySelector('#delivery_text')
      this.variantInventory = this.getVariantInventory();

      // Bind to on:variant:change event for this product
      const variantPicker = this.closest('.product-info').querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }

      // Init
      this.updateInventory(
        parseInt(this.dataset.inventoryQuantity, 10),
        this.dataset.variantAvailable === 'true'
      );
    }

    /**
     * Gets the inventory data for all product variants
     * @returns {?object}
     */
    getVariantInventory() {
      const dataEl = this.querySelector('[type="application/json"]');
      return this.variantInventory || JSON.parse(dataEl.textContent);
    }

    /**
     * Handles a 'change' event on the variant picker element
     * @param {object} evt - Event object
     */
    handleVariantChange(evt) {
      if (evt.detail.variant) {
        const inventory = this.variantInventory.filter(
          (variant) => variant.id === evt.detail.variant.id
        )[0];

        this.updateInventory(inventory.inventory_quantity, inventory.available, evt.detail.variant.id);


        let variantTextScript = this.querySelector('#delivery_text_script')
        if (variantTextScript) {
          // find the selected variant (evt.detail.variant.id) that matches the variantId in the script
          variantTextScript = JSON.parse(variantTextScript.textContent)
          console.log(variantTextScript)

          const selectedVariant = variantTextScript.filter((variant) => variant.variantId === evt.detail.variant.id)[0]

          let customDeliveryText = selectedVariant.customDelivery;

          let locationBasedInventory = selectedVariant.locationBasedInventory

          let continueSelling = selectedVariant.continueSelling

          console.log(selectedVariant)

          // locationbasedinventory looks like this "1," or something like that. I want to split it and get value befor and after the comma
          locationBasedInventory = locationBasedInventory.split(',');

          // now turn the value into an integer if it is empty
          if (locationBasedInventory[0] == "") {
            locationBasedInventory[0] = 0
          }

          if (locationBasedInventory[1] == "") {
            locationBasedInventory[1] = 0
          }

          locationBasedInventory[0] = parseInt(locationBasedInventory[0])
          locationBasedInventory[1] = parseInt(locationBasedInventory[1])

          if (locationBasedInventory[0] >= 1) {
            this.inventoryTextEle.innerHTML = "- 1-2 dage"
          } else if (locationBasedInventory[0] <= 0 && locationBasedInventory[1] <= 0 && continueSelling == 'deny') {
            this.inventoryTextEle.innerHTML = ""
          } else if (locationBasedInventory[0] <= 0 && locationBasedInventory[1] >= 1) {
            this.inventoryTextEle.innerHTML = "- 3-5 dage"
          } else if (locationBasedInventory[0] <= 0 && locationBasedInventory[1] <= 0 && customDeliveryText && continueSelling != 'deny') {
            this.inventoryTextEle.innerHTML = customDeliveryText
          }
        }






      } else {
        this.updateInventory(0, false);
        this.hidden = true;
      }
    }

    /**
     *
     * Updates the inventory notice
     * @param {number} count - the inventory quantity available
     * @param {boolean} available - whether current variant is available
     */
    updateInventory(count, available, variantId) {
      let inventoryLevel;
      if (count <= 0) {
        if (available) {
          inventoryLevel = 'in_stock';
        } else {
          inventoryLevel = 'none';
        }
      } else if (count <= parseInt(this.dataset.thresholdVeryLow, 10)) {
        inventoryLevel = 'very_low';
      } else if (count <= parseInt(this.dataset.thresholdLow, 10)) {
        inventoryLevel = 'low';
      } else {
        inventoryLevel = 'normal';
      }


      const inventoryLevelsScrit = this.querySelector('#delivery_text_script');
      let extraInfo = ""
      let selectedVariant = null
      if (inventoryLevelsScrit) {
        // find the selected variant (evt.detail.variant.id) that matches the variantId in the script
        const inventoryLevelsScritData = JSON.parse(inventoryLevelsScrit.textContent)


        let selectedVariantId = variantId || inventoryLevelsScritData.find(
          (variant) => variant["default_selected_variant"] === true
        )?.variantId




        if (selectedVariantId) {
          selectedVariant = inventoryLevelsScritData.find((variant) => variant.variantId === selectedVariantId)

          const variantAvailable = selectedVariant.available
          const inventoryLocationData = selectedVariant.locationBasedInventory.split(',')
          const inventoryAtLocationOne = parseInt(inventoryLocationData[0]) || 0
          const inventoryAtLocationTwo = parseInt(inventoryLocationData[1]) || 0

          const onlineAndInStoreText = window.theme.strings.onlineandinstore
          const onlineText = window.theme.strings.online
          if (variantAvailable) {
            if (inventoryAtLocationOne > 0) {

              extraInfo = " " + onlineAndInStoreText
            } else {
              extraInfo = " " + onlineText
            }
          } else {
            extraInfo = "";
          }
        }
      }


      if (this.dataset.showNotice === 'always'
        || (this.dataset.showNotice === 'low' && inventoryLevel.includes('low'))) {
        this.hidden = false;

        // Set the inventory level data attribute
        this.setAttribute('data-inventory-level', inventoryLevel);

        // Determine whether to show the count or not
        if (inventoryLevel !== 'in_stock' && (this.dataset.showCount === 'always' || (this.dataset.showCount === 'low' && inventoryLevel.includes('low')))) {
          this.inventoryNotice.innerText = theme.strings.onlyXLeft.replace('[quantity]', count);
        } else if (inventoryLevel.includes('low')) {
          this.inventoryNotice.innerText = theme.strings.lowStock;
        } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
          this.inventoryNotice.innerText = theme.strings.inStock;
        } else if (inventoryLevel === 'none') {
          this.inventoryNotice.innerText = theme.strings.noStock;
        }

        this.inventoryNotice.innerHTML += extraInfo;



        // Update urgency message if needed
        if (this.urgencyMessage) {
          if (inventoryLevel === 'very_low') {
            this.urgencyMessage.innerHTML = this.dataset.textVeryLow;
          } else if (inventoryLevel === 'low') {
            this.urgencyMessage.innerHTML = this.dataset.textLow;
          } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
            this.urgencyMessage.innerHTML = this.dataset.textNormal;
          } else if (inventoryLevel === 'none') {
            this.urgencyMessage.innerHTML = this.dataset.textNoStock;
          }
        }

        // Update the bar indicator
        if (this.indicatorBar) {
          this.indicatorBar.hidden = false;

          let newWidth;
          if (count >= this.dataset.scale || inventoryLevel === 'in_stock') {
            newWidth = 100;
          } else {
            newWidth = ((100 / parseInt(this.dataset.scale, 10)) * count).toFixed(1);
          }
          this.indicatorBar.querySelector('span').style.width = `${newWidth}%`;
        }
      } else {
        this.hidden = true;
      }
    }
  }

  customElements.define('product-inventory', ProductInventory);
}
